module.exports = __webpack_public_path__ + "static/media/ob_d.9691b04d.svg";